import { SelectedMenu } from 'rangeConfig/@types';

// Selected menu for open frames are handled by the frames product group selected menu.
const selectedMenu: SelectedMenu = {
  menuTitle: '',
  behaviors: {
    productDeleted: []
  },
  content: []
};

export default selectedMenu;
